import getPriceForEventMember from '../util/getPriceForEventMember'
import { EventMember, EventPriceCategory } from '../shared/types'

const getPriceForAllEventMembers = (eventMember: EventMember[], eventPrices: EventPriceCategory[]) => {
  let price = 0
  eventMember.map(member => {
    price += getPriceForEventMember(member, eventPrices)
  })
  return price
}

export default getPriceForAllEventMembers
